export default __webpack_public_path__ + "static/media/Econnect.d298aa0a.svg";